import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { useRecipes } from '@/features/recipes/useRecipes'

// Local type definition — avoids cross-feature type import
interface RecipeItem {
  id: string
  name: string
  isFavourite: boolean
}

export function PlanningNudge() {
  const { t } = useTranslation('home')
  const { data: recipes } = useRecipes()

  const favourites = (recipes as RecipeItem[] | undefined)?.filter(r => r.isFavourite) ?? []

  return (
    <div className="flex flex-col items-center gap-6 px-4 py-8 max-w-md mx-auto text-center">
      <h2 className="text-xl font-semibold text-ink">
        {t('planningNudge.tagline')}
      </h2>

      {favourites.length > 0 && (
        <div className="w-full">
          <h3 className="text-sm font-medium text-muted mb-3 text-left">
            {t('planningNudge.favouritesHeading')}
          </h3>
          <div className="flex gap-3 overflow-x-auto pb-2">
            {favourites.map(recipe => (
              <Link
                key={recipe.id}
                to="/plan"
                className="flex-shrink-0 rounded-lg border border-line bg-canvas px-4 py-3 text-sm font-medium text-ink hover:border-accent transition-colors"
              >
                {recipe.name}
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="flex flex-col gap-3 w-full">
        <Link
          to="/templates"
          className="rounded-md bg-primary px-4 py-3 text-sm font-medium text-white text-center"
        >
          {t('planningNudge.startWithTemplates')}
        </Link>
        <Link
          to="/recipes"
          className="rounded-md border border-line px-4 py-3 text-sm font-medium text-ink text-center"
        >
          {t('planningNudge.addFromLibrary')}
        </Link>
      </div>
    </div>
  )
}
